import type { Asset, Category } from "../model/asset.model";

function normalize(q: string): string {
  return q.trim().toLowerCase();
}

export function parsePrimaryTag(tags: string): {
  primary: string;
  rest: string;
} {
  const parts = tags.split("•");
  const primary = (parts[0] ?? "").trim();
  const rest =
    parts.length > 1 ? parts.slice(1).join("•").trim() : "";
  return { primary, rest };
}

export function categoryMatches(category: Category, q: string): boolean {
  if (!q) return true;
  const n = normalize(q);
  return (
    category.name.toLowerCase().includes(n) ||
    category.id.toLowerCase().includes(n)
  );
}

export function assetMatches(asset: Asset, q: string): boolean {
  if (!q) return true;
  const n = normalize(q);
  return (
    asset.title.toLowerCase().includes(n) ||
    asset.tags.toLowerCase().includes(n) ||
    asset.description.toLowerCase().includes(n)
  );
}

export function filterCategoriesBySearch(
  categories: Category[],
  searchQuery: string
): Category[] {
  const q = normalize(searchQuery);
  if (!q) return categories;

  return categories
    .map((cat) => {
      const wholeCategory = categoryMatches(cat, searchQuery);
      const assets = wholeCategory
        ? cat.assets
        : cat.assets.filter((a) => assetMatches(a, searchQuery));
      return { ...cat, assets };
    })
    .filter((cat) => cat.assets.length > 0);
}

export function findUniqueCategoryBySearchQuery(
  categories: Category[],
  searchQuery: string
): Category | null {
  const q = normalize(searchQuery);
  if (!q) return null;
  const matches = categories.filter((c) => categoryMatches(c, searchQuery));
  return matches.length === 1 ? matches[0] : null;
}
